var path = 'user/user-card.tpl.html';
var html = "\n<div class=\"tb-uppercase\">{{item ? ( ( item.firstName ? item.firstName : '' ) + ' ' + ( item.lastName ? item.lastName : '') ) : ''}}</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-card.tpl.html
// module id = 1528
// module chunks = 1